iScreenWizard.factory('Klantorganisatie', function ($q, Ajax) {

    var data = {};

    data.current = function() {
        return $q(function (resolve, reject) {
            Ajax.get('klantorganisatie/').then(function (response) {
                var klantorganisatie = response.data;
                resolve(klantorganisatie);
            }, reject);
        });
    };

    return data;
});